@for (item of users(); track $index) {
  <ion-item lines="none">
    <ion-checkbox (ionChange)="onUser($event, item)">{{ item.name }}</ion-checkbox>
  </ion-item>
}
<div class="ion-margin-top ion-margin-bottom">
  <ion-button color="light"
    (click)="addUser()">
    {{ 'report.apartmentRound.addUser' | translate }}
  </ion-button>
</div>
@for (item of report().participants; track $index; let i = $index) {
  <ion-item lines="none">
    {{ item.name }}
    <ion-button slot="end"
      color="danger"
      (click)="onRemoveUser(i)">
      <ion-icon slot="icon-only"
        name="trash-outline"></ion-icon>
    </ion-button>
  </ion-item>
} @empty {
  <p>{{ 'report.apartmentRound.noParticipants' | translate }}</p>
}
<app-select-day [id]="'reportDate'"
  [color]="'light'"
  [name]="'calendar.title'"
  [value]="report().made"
  (changed)="onDateChange($event)"></app-select-day>
@for (item of fields; track $index) {
  <h4>{{ 'report.playground.items.' + item.title + '.title' | translate }}</h4>
  @for (subitem of item.items; track $index) {
    <div class="playground-item">
      <h3>{{ 'report.playground.items.' + item.title + '.subitems.' + subitem + '.title' | translate }}</h3>
      <p>{{ 'report.playground.items.' + item.title + '.subitems.' + subitem + '.info' | translate }}</p>
      <ion-item color="light"
        lines="none">
        <ion-toggle
          [(ngModel)]="report()[item.title][subitem].checked">{{ 'report.playground.checked' | translate }}</ion-toggle>
      </ion-item>
      <ion-label>{{ 'report.playground.item' | translate }}</ion-label>
      <ion-item color="light"
        lines="none">
        <ion-input [(ngModel)]="report()[item.title][subitem].item"></ion-input>
      </ion-item>
      <ion-label>{{ 'report.playground.condition' | translate }}</ion-label>
      <ion-item color="light"
        lines="none">
        <ion-input [(ngModel)]="report()[item.title][subitem].condition"></ion-input>
      </ion-item>
      @if (!report()[item.title][subitem].checked) {
        <ion-label>{{ 'report.playground.riskLevel' | translate }}</ion-label><br />
        <ion-radio-group [allowEmptySelection]="true"
          [value]="report()[item.title][subitem].riskLevel"
          (ionChange)="onRiskChange(item.title, subitem, $event)">
          <ion-radio value="1"
            labelPlacement="end">1</ion-radio>
          <ion-radio value="2"
            labelPlacement="end">2</ion-radio>
          <ion-radio value="3"
            labelPlacement="end">3</ion-radio>
          <ion-radio value="4"
            labelPlacement="end">4</ion-radio>
          <ion-radio value="5"
            labelPlacement="end">5</ion-radio>
        </ion-radio-group><br />
        <ion-label>{{ 'report.playground.risk' | translate }}</ion-label>
        <ion-item color="light"
          lines="none">
          <ion-input [(ngModel)]="report()[item.title][subitem].risk"></ion-input>
        </ion-item>
      }
      <app-images [showCamera]="'item.addImage'"
        [images]="report()[item.title][subitem].images"
        [canDelete]="true"
        (openCamera)="onImage(item.title, subitem, $event)"
        (deleted)="onDeleteImage(item.title, subitem, $event)"></app-images>
    </div>
  }
}